import styled from 'styled-components';
import backgroundImage from './../../../assets/background-header.webp'
import {theme} from './../../../styles/theme'

interface ResponsiveProps {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}


export const HeaderWrapper = styled.header<ResponsiveProps>`
  position: relative;
  //height: 110px; /* Altura fixa para o header */
  height: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '85px' : isMobileMedium ? '85px' : isMobileBig ? '95px' : isMiniNotebook ? '105px' : '110px'};
  width: 100%;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-width: 100vw;
`;

export const HeaderContent = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding-top:5px;
  padding-right:15px;
  
  max-width: 100vw;

  padding-right: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook }) =>
    isMobileMini ? '15px' : isMobileMedium ? '15px' : isMobileBig ? '15px' : isMiniNotebook ? '15px' : '20px'};
  margin-left: 25px;
  
  /* Outros breakpoints permanecem iguais */
`;
